import React from 'react';
import BrandPartners from '../components/partners/BrandPartners';
// import Stats from '../components/home/Stats';
// import Clients from '../components/home/Clients';
// import Awards from '../components/home/Awards';

const PartnersPage = () => {
    return (
        <>
            <BrandPartners />
        </>
    );
};

export default PartnersPage;